import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d6eb18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asahi-information-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.$t('An order has been created for you.')), 1),
    _createVNode(_component_AsahiButton, {
      onClick: _ctx.redirectToPending,
      type: "header",
      color: "primary-white"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Complete the order')), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}